import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { transientOptions } from 'src/utils';
import { UploadAvatarField } from './UploadAvatarField';
import { useGetUserAvatar } from './useGetUserAvatar';

type ProfilePictureSize = 'small' | 'medium' | 'large';

interface Props {
  size?: ProfilePictureSize;
  withFileUpload?: boolean;
}

const getProfilePictureSize = (size: ProfilePictureSize) => {
  switch (size) {
    case 'large':
      return '10rem';
    case 'medium':
      return '5rem';
    case 'small':
    default:
      return '2.5rem';
  }
};

interface ImgContainerTransientProps {
  $imageHover: boolean;
}
const ImageContainer = styled('div', transientOptions)<ImgContainerTransientProps>`
  position: relative;
  z-index: 60;
  border-radius: 50%;

  &:hover > label {
    display: block;
  }

  &:hover::after {
    opacity: ${props => (props.$imageHover ? 0.4 : 0)};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0);
    opacity: 0;
    transition: all 1s;
  }
`;

interface ProfileImgTransientProps {
  $dimensions: string;
}
const ProfileImage = styled(
  'img',
  transientOptions
)<ProfileImgTransientProps>(
  props => `
    position: relative;
    width: ${props.$dimensions};
    height: ${props.$dimensions};
    border-radius: 50%;
`
);

export const UserPicture = ({ size = 'small', withFileUpload = false }: Props) => {
  const [dimensions, setDimensions] = useState(getProfilePictureSize(size));
  const avatar = useGetUserAvatar();

  useEffect(() => {
    setDimensions(getProfilePictureSize(size));
  }, [size]);

  return (
    <ImageContainer $imageHover={withFileUpload}>
      {/* TODO: remove Date useless logic after backend adds timestamps to the actual images */}
      <ProfileImage src={`${avatar}?d=${new Date().getTime()}`} alt='avatar' $dimensions={dimensions} />
      {withFileUpload && <UploadAvatarField />}
    </ImageContainer>
  );
};
